export var EPromptType;
(function (EPromptType) {
    EPromptType["ChatSystem"] = "chat_system";
    EPromptType["ReformulateQuery"] = "reformulate_query";
    EPromptType["KnowledgeProcessorSystem"] = "knowledge_processor_system";
    EPromptType["KnowledgeProcessorTemplate"] = "knowledge_processor_template";
    EPromptType["ChatSystemTemplate"] = "chat_system_template";
    EPromptType["TopicClassificationTemplate"] = "topic_classification_template";
    EPromptType["TopicClassificationSystemTemplate"] = "topic_classification_system_template";
    EPromptType["MessageMemoryKnowledgeProcessorSystem"] = "message_memory_knowledge_processor_system";
    EPromptType["MCPBotSystemTemplate"] = "mcp_bot_system_template";
    EPromptType["MCPKnowledgeProcessorSystemTemplate"] = "mcp_knowledge_processor_system_template";
    EPromptType["MessageMemoryKnowledgeProcessorTemplate"] = "message_memory_knowledge_processor_template";
    EPromptType["ChatSystemVoiceTemplate"] = "chat_system_voice_template";
    EPromptType["MessagesMemoryRerankerSystemTemplate"] = "messages_memory_reranker_system_template";
    EPromptType["MessagesMemoryRerankerDocumentTemplate"] = "messages_memory_reranker_document_template";
    EPromptType["HybridSearchRerankerSystemTemplate"] = "hybrid_search_reranker_system_template";
    EPromptType["HybridSearchRerankerDocumentTemplate"] = "hybrid_search_reranker_document_template";
    EPromptType["VisionSystemTemplate"] = "vision_system_template";
    EPromptType["VisionSystemVoiceTemplate"] = "vision_system_voice_template";
    EPromptType["ChatUserSystemRefiner"] = "chat_user_system_refiner";
    EPromptType["ChatUserVoiceSystemRefiner"] = "chat_user_voice_system_refiner";
    EPromptType["AsyncAgentTaskResponseTemplate"] = "async_agent_task_response_template";
    EPromptType["ExternalMessageTemplate"] = "external_message_template";
})(EPromptType || (EPromptType = {}));
//# sourceMappingURL=prompt.enum.js.map